import type { DocumentNode } from "graphql/language/ast";
import { GraphQLClient, Variables } from "graphql-request";

import { Logger } from "~/utils/logger";

export class Client {
  private vendorClient: GraphQLClient;
  constructor(private readonly url: string) {
    this.vendorClient = new GraphQLClient(url);
  }
  async query<T, V = Variables>(
    query: string | DocumentNode,
    variables?: V
  ): Promise<T> {
    try {
      return await this.vendorClient.request(query, variables);
    } catch (error) {
      Logger.logError(error);
      throw error;
    }
  }
}
